export class TaskOrderExtras {
  id: number;
  orderextradelivered: number;
  orderextravalue: number;
  orderextrapaid: number;
  balancevalue: number;
  percentage: number;
}
